import { Injectable } from "@angular/core";
import { ServiceConfig } from "./service-config";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class AccountService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + "/api/account/";
  private data: any;

  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
  }

  public index() {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + "?token=" + this.data.token;
    return this.http.get<any>(url);
  }

  public getAccounts() {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + "/accounts?token=" + this.data.token;
    return this.http.get<any>(url);
  }

  public update(body) {
    let url = this.baseUrl + "/update?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public changePassword(body) {
    let url = this.baseUrl + "/change_password?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getAccountByAgent() {
    let url = this.baseUrl + "/getAccountByAgent?token=" + this.data.token;
    return this.http.get<any>(url);
  }
  async getLists(body: any): Promise<any> {
    const data = JSON.parse(localStorage.getItem("currentSmmData"));
    return await this.http
      .post<any>(this.baseUrl + "get-list?token=" + data.token, body)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/account.service.ts